import * as Sentry from '@sentry/react';

// api.js
const API_BASE_URL = window.reactPress.api.rest_url + 'wc/store';
// const API_BASE_URL = 'https://stage.yeschef.me/wp-json/wc/store';

// Helper function to fetch and store the nonce
let nonce = null;

export const updateNonce = async () => {

  const response = await fetch(`${API_BASE_URL}/cart`);
  nonce = response.headers.get('Nonce');
}

const fetchWithNonce = async (url, options = {}) => {
  try {
    if (!nonce) {
      // If we don't have a nonce, make a simple GET request to fetch it
      const response = await fetch(`${API_BASE_URL}/cart`);
      nonce = response.headers.get('Nonce');
    }

    // Add the nonce to the headers for the request
    const headers = {
      ...options.headers,
      'Nonce': nonce,
    };

    // Make the actual API call with the nonce included
    const finalOptions = { ...options, headers };
    return fetch(url, finalOptions);
  } catch (error) {
    // Log the error to Sentry
    Sentry.captureException(error);
    throw error;
  }
};

// Get the cart
export const getCartData = async () => {
  try {
    // console.log("GET CART: ", API_BASE_URL);
    const response = await fetchWithNonce(`${API_BASE_URL}/cart`);
    if (response.ok) {
      return await response.json();
    } else {
      // If response is not OK, capture the error along with response details
        const errorMessage = `Network response was not ok. Status: ${response.status}, ${response.statusText}`;
        const error = new Error(errorMessage);
        error.response = response; // Attach the response object to the error
        throw error;
    }
  } catch (error) {
    // Log the error to Sentry
    Sentry.captureException(error);
    // console.error("Error fetching cart data: ", error);
    throw error;
  }
};

// Add product to cart
export const addCartProduct = async (productId, quantity) => {
  try {
    const response = await fetchWithNonce(`${API_BASE_URL}/cart/add-item`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity,
      }),
    });

    if (response.ok) {
      return await response.json();
    } else {
      // If response is not OK, capture the error along with response details
        const errorMessage = `Network response was not ok. Status: ${response.status}, ${response.statusText}`;
        const error = new Error(errorMessage);
        error.response = response; // Attach the response object to the error
        throw error;
    }
  } catch (error) {
    // Log the error to Sentry
    Sentry.captureException(error);
    // console.error("Error adding product to cart: ", error);
    throw error;
  }
};

// Apply coupon
export const applyCouponCode = async (couponCode) => {
  try {
    const response = await fetchWithNonce(`${API_BASE_URL}/cart/apply-coupon`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        code: couponCode,
      }),
    });

    if (response.ok) {
      return await response.json();
    } else {
      // If response is not OK, capture the error along with response details
        const errorMessage = `Network response was not ok. Status: ${response.status}, ${response.statusText}`;
        const error = new Error(errorMessage);
        error.response = response; // Attach the response object to the error
        throw error;
    }
  } catch (error) {
    // Log the error to Sentry
    Sentry.captureException(error);
    // console.error("Error applying coupon code: ", error);
    throw error;
  }
};

// Remove coupon
export const removeCouponCode = async (couponCode) => {
  try {
    const response = await fetchWithNonce(`${API_BASE_URL}/cart/remove-coupon`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        code: couponCode,
      }),
    });

    if (response.ok) {
      return await response.json();
    } else {
      // If response is not OK, capture the error along with response details
        const errorMessage = `Network response was not ok. Status: ${response.status}, ${response.statusText}`;
        const error = new Error(errorMessage);
        error.response = response; // Attach the response object to the error
        throw error;
    }
  } catch (error) {
    // Log the error to Sentry
    Sentry.captureException(error);
    // console.error("Error removing coupon: ", error);
    throw error;
  }
};

// Get Order
export const getOrder = async () => {

  return fetchWithNonce(`${API_BASE_URL}/checkout`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        // If the response is not OK, handle the error
        return response.json().then(err => {
          // This is where you handle the actual error object
          console.log("ERROR: ", err);
          throw err;
        });
      }
    })

}


// Process order use checkout API
export const processOrder = async (billingInfo, paymentMethodId, isGift) => {
  let requestBody = {
    is_gift: isGift,
    billing_address: billingInfo,
    create_account: true
  };

  if (!!paymentMethodId) {
    requestBody.payment_method = "stripe";
    requestBody.payment_data = [{
      "key": "stripe_source",
      "value": paymentMethodId
    }];
  }
  // else{
  //   requestBody.payment_method = "cheque";
  //   requestBody.payment_data = [];
  // }

  return fetchWithNonce(`${API_BASE_URL}/checkout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        // If the response is not OK, handle the error
        return response.json().then(err => {
          // This is where you handle the actual error object
          console.log("ERROR: ", err);
          throw err;
        });
      }
    })
  // return response.json();
};

export const sendSignUpEvent = async (email, original_email, tf_uuid) => {
  try {
    const response = await fetchWithNonce(`${window.reactPress.api.rest_url}yes_chef/v1/has_orders/send_event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        original_email: original_email,
        tf_uuid: tf_uuid,
        tf_submit: localStorage.getItem('tf_submit'),
      }),
    });

    if (response.ok) {
      return await response.json();
    } else {
      // If response is not OK, capture the error along with response details
        const errorMessage = `Network response was not ok. Status: ${response.status}, ${response.statusText}`;
        const error = new Error(errorMessage);
        error.response = response; // Attach the response object to the error
        throw error;
    }
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }

}

// Get the email from typeform
export const getFormData = async (typeform_uuid, form_id) => {
  try {
    // console.log("Get Form: ", window.reactPress.api.rest_url);
    const response = await fetch(`${window.reactPress.api.rest_url}yes_chef/v1/tf_response?user_uuid=` + typeform_uuid + '&form_id=' + form_id);
    if (response.ok) {
      return await response.json();
    } else {
      // If response is not OK, capture the error along with response details
        const errorMessage = `Network response was not ok. Status: ${response.status}, ${response.statusText}`;
        const error = new Error(errorMessage);
        error.response = response; // Attach the response object to the error
        throw error;
    }
  } catch (error) {
    // Log the error to Sentry
    Sentry.captureException(error);
    // console.error("Error fetching cart data: ", error);
    throw error;
  }
};

// Trigger the signup event
export const scheduleSignup = async (data) => {
  try {
    const response = await fetch(`${window.reactPress.api.rest_url}yes_chef/v1/schedule_signup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (response.ok) {
      return await response.json();
    } else {
      // If response is not OK, capture the error along with response details
        const errorMessage = `Network response was not ok. Status: ${response.status}, ${response.statusText}`;
        const error = new Error(errorMessage);
        error.response = response; // Attach the response object to the error
        throw error;
    }
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const updateKlaviyoProfile = async (email, properties) => {
  try {
    const response = await fetch(`${window.reactPress.api.rest_url}yes_chef/v1/klaviyo/update_profile`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        properties
      }),
    });

    if (!response.ok) {
      const errorMessage = `Network response was not ok. Status: ${response.status}, ${response.statusText}`;
      const error = new Error(errorMessage);
      error.response = response;
      throw error;
    }

    return await response.json();
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const sendSignupToZapier = async (tf_uuid, email) => {
  const url = `${window.reactPress.api.rest_url}yes_chef/v1/zapier_tf_hook`;

  const payload = { tf_uuid, email, tf_submit: localStorage.getItem('tf_submit') };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const result = await response.json();
    console.log('Success:', result);
  } catch (error) {
    console.error('Error sending data:', error);
  }
};

// Get plans
export const fetchPlans = async () => {
  let plans = [];
  try {
    plans = window.checkoutConfig.plans;
    return plans;

  } catch (error) {
    Sentry.captureException(error);
    // console.log("Error fetching plans ", error);
    throw error;
  }
};

export const fetchCart = async (product_sku, coupon) => {
  try {
    const response = await fetch(`${window.reactPress.api.rest_url}yes_chef/v1/checkout?product_sku=${product_sku}&coupon=${coupon}&nonce=${window.reactPress.api.nonce}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // 'X-WP-Nonce': window.reactPress.api.nonce
      },
      body: ''
    });

    if (response.ok) {
      return await response.json();
    } else {
      // Handle non-ok responses
      const errorResponse = await response.json();
      throw new Error(errorResponse.message || 'Error fetching cart.');
    }
  } catch (error) {
    // Log the error to Sentry
    Sentry.captureException(error);
    // console.error("Error fetching cart: ", error);
    throw error;
  }
};

// Mock data representing the API response
const mockPlans = [
  {
    product_sku: 'yc_yearly-b',
    // product_id: 316424,
    product_id: 275573,
    title: '12 Months',
    price: 359.88,
    discounted_price: 155.88,
    subscription_period: 'annual',
    show_monthly_price: true,
    showSavings: true,
    planInfo: null,
    checkout_note: "Billed now for 12 months ($12.99/month), then $239.88 yearly."
  },
  {
    product_sku: 'yc_monthly-b',
    // product_id: 316427,
    product_id: 275579,
    title: '1 Month',
    price: 29.99,
    discounted_price: null,
    subscription_period: 'month',
    show_monthly_price: false,
    showSavings: false,
    planInfo: "Save $204 in the first year with the 12-month plan. Fully refundable for 30 days.",
    checkout_note: "Billed monthly $29.99."
  },
  {
    product_sku: 'yc_lifetime-b',
    // product_id: 316437,
    product_id: 275580,
    title: 'Lifetime',
    price: 599,
    discounted_price: 489,
    subscription_period: 'lifetime',
    show_monthly_price: false,
    showSavings: false,
    planInfo: null,
    checkout_note: "Billed once $599."
  },
];